// Import polyfills for IE11
import 'es5-shim';
import 'json3';

// Import vendor CSS
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'angular-loading-bar/build/loading-bar.css';
import 'angular-toastr/dist/angular-toastr.css';
import 'fullcalendar/dist/fullcalendar.css';

// Import vendor CSS from vendor directory
import 'angularjs-datepicker/dist/angular-datepicker.css';
import 'ng-img-crop/compile/minified/ng-img-crop.css';

// Import app CSS
import './styles/style.css';
import './styles/style-responsive.css';
import 'angular';
import 'bootstrap/dist/js/bootstrap.js';

// Angular modules
import 'angular-animate';
import 'angular-aria';
import 'angular-cookies';
import 'angular-messages';
import 'angular-resource';
import 'angular-route';
import 'angular-sanitize';
import 'angular-touch';
import moment from 'moment';

window.moment = moment;
import 'angular-moment';
import 'angular-loading-bar';
import 'jquery-ui-dist/jquery-ui.js';
import 'angular-ui-bootstrap';
import 'angular-local-storage';
import 'angular-toastr';
import 'stacktrace-js';
// import 'firebase';
// import 'angularfire';
import 'angular-uuid4';
import 'raven-js';
import Raven from 'raven-js';

window.Raven = Raven;
import _ from 'lodash';
window._ = _;

import 'ng-file-upload';
import 'angular-recaptcha';
import 'file-saver';

import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;

// Import vendor libraries from vendor directory
import 'ng-backstretch/dist/ng-backstretch.js';
import 'jquery.scrollto';
import 'angularjs-datepicker/dist/angular-datepicker.js';
import 'jquery.nicescroll';
import 'angular-nicescroll/angular-nicescroll.js';
import 'fullcalendar/dist/fullcalendar.js';
import 'angular-ui-calendar';
import 'ng-img-crop/compile/minified/ng-img-crop.js';
import 'blob-polyfill';
import 'angular-file-saver/dist/angular-file-saver.bundle.js';

// Import app scripts
import './scripts/app.js';
import './scripts/app.routes.js';

// Import configs
import './scripts/configs/exception.config.js';

// Import constants
import './scripts/constants/constants.js';

// Import controllers
import './scripts/controllers/base.js';
import './scripts/controllers/main.js';
import './scripts/controllers/about.js';
import './scripts/controllers/login.js';
import './scripts/controllers/register.js';
import './scripts/controllers/notfound.js';
import './scripts/controllers/index.js';
import './scripts/controllers/customers.js';
import './scripts/controllers/schedules.js';
import './scripts/controllers/schedule.details.js';
import './scripts/controllers/schedule.jobs.js';
import './scripts/controllers/jobs.complete.js';
import './scripts/controllers/customer.details.js';
import './scripts/controllers/customer.orders.js';
import './scripts/controllers/newcustomer.js';
import './scripts/controllers/neworder.js';
import './scripts/controllers/newhome.js';
import './scripts/controllers/users.js';
import './scripts/controllers/newschedule.js';
import './scripts/controllers/newuser.js';
import './scripts/controllers/user.details.js';
import './scripts/controllers/profile.details.js';
import './scripts/controllers/user.changepassword.js';
import './scripts/controllers/settings.js';

// Import services
import './scripts/services/authentication.service.js';
import './scripts/services/authInterceptor.service.js';
import './scripts/services/user.service.js';
import './scripts/services/flash.service.js';
import './scripts/services/customer.service.js';
import './scripts/services/profile.service.js';
import './scripts/services/events.service.js';
import './scripts/services/modal.service.js';
import './scripts/services/lookup.service.js';
import './scripts/services/analytics.service.js';
import './scripts/services/dashboard.service.js';
import './scripts/services/schedule.service.js';
import './scripts/services/error.service.js';
import './scripts/services/errorlog.service.js';
import './scripts/services/order.service.js';
import './scripts/services/stacktrace.service.js';
import './scripts/services/base.service.js';
import './scripts/services/raven.service.js';
import './scripts/services/exceptionhandler.provider.js';
import './scripts/services/moment.service.js';
import './scripts/services/fullcalendar.service.js';
import './scripts/services/postcode.service.js';
import './scripts/services/firebase.service.js';
import './scripts/services/permission.service.js';
import './scripts/services/setting.service.js';
import './scripts/services/job.service.js';
import './scripts/services/route.service.js';
import './scripts/services/schedule.jobs.service.js';

// Import factories
import './scripts/domain/job.factory.js';

// Import directives
import './scripts/directives/mycurrenttime.js';
import './scripts/directives/profile.directive.js';
import './scripts/directives/lockscreen.directive.js';
import './scripts/directives/login.directive.js';
import './scripts/directives/match.directive.js';
import './scripts/directives/changepassword/changepassword.directive.js';
import './scripts/directives/permission.directive.js';
import './scripts/directives/job-list.directive.js';
import './scripts/directives/job/job-arrival.directive.js';
import './scripts/directives/missed-customers.component.js';
import './scripts/directives/missed-customers-list/missed-customers-list.component.js';

// Import filters
import './scripts/filters/displayname.js';
import './scripts/filters/address.js';

// Import jQuery UI scripts
import './scripts/ui.js';
